import React, { useState, useEffect } from "react";
import { Modal, Table, Input, Tag } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { http } from "../../services/http";
import moment from "moment";

const AcceptedModal = ({ visible, data, onClose }) => {
  const { t } = useTranslation();

  const [responsiblePersonData, setResponsiblePersonData] = useState([]);
  const [responsiblePerson, setResponsiblePerson] = useState("");
  const [status, setStatus] = useState("");
  const [salesData, setSalesData] = useState(null);
  const [salesLoading, setSalesLoading] = useState(false);
  const [stockTransfer, setStockTransfer] = useState([]);

  const orderStatus = [
    { label: "Barchasi", value: "" },
    { label: "Tasdiqlandi", value: "Tasdiqlandi" },
    { label: "Mas'ulga biriktirildi", value: "Biriktirildi" },
    { label: "Buyurtma yuklandi", value: "BuyurtmaYuklandi" },
    { label: "Yuklash tasdiqlandi", value: "YuklashTasdiqlandi" },
    { label: "-", value: "-" },
  ];

  useEffect(() => {
    fetchResponsibleManagers();
  }, []);

  useEffect(() => {
    if (data) {
      fetchByDocEntry(data.docEntry);
    }
  }, [data, visible]);

  const fetchByDocEntry = async (docEntry) => {
    setSalesLoading(true);
    try {
      const { data } = await http.get(
        `api/sales/stock-transfer-request/${docEntry}`,
      );

      const resData = data.data;
      const status = resData.orderStatus
        ? orderStatus.find((status) => {
            return status.value === resData.orderStatus;
          })
        : "-";
      setStatus(status.label ?? "-");
      setSalesData(resData);
      const responsiblePerson = resData.responsiblePerson
        ? responsiblePersonData.find((item) => {
            return item.employeeId === Number(resData.responsiblePerson);
          })
        : "-";
      setResponsiblePerson(responsiblePerson);
      setStockTransfer(resData.stockTransferLines);
    } catch (err) {
      console.log(err);
    } finally {
      setSalesLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      const responsible = responsiblePersonData.find(
        (responsible) =>
          responsible.employeeId === Number(data?.responsiblePerson),
      );
      setResponsiblePerson(
        `${responsible?.firstName ?? ""} ${responsible?.lastName ?? ""}`,
      );
    }
  }, [data]);

  const columns = [
    {
      title: t("item"),
      dataIndex: "itemDescription",
      key: "itemDescription",
    },
    {
      title: t("quantity"),
      dataIndex: "quantity",
      key: "quantity",
      render: (text, record) => {
        const formattedText = new Intl.NumberFormat("fr-FR").format(text);
        return `${formattedText}`;
      },
    },
    {
      title: t("measureUnit"),
      dataIndex: "measureUnit",
      key: "measureUnit",
    },
  ];

  const fetchResponsibleManagers = async () => {
    try {
      const { data } = await http.get(
        `api/sales/warehouse-employee-info?skip=0`,
      );
      setResponsiblePersonData(data.data);
      console.log("warehouse-employee", data.data);
    } catch (err) {
      console.log(err);
    }
  };

  if (!data) return null;

  return (
    <Modal
      title={
        <h1 className="font-nunito text-xl font-extrabold text-[#000000]">
          {t("order")} № {data.docEntry}
        </h1>
      }
      visible={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={<CloseOutlined />}
      width="70%"
      bodyStyle={{ maxHeight: "80vh", overflowY: "auto" }}
    >
      <div className="w-full px-4 sm:px-14">
        <Table
          columns={columns}
          dataSource={stockTransfer}
          pagination={false}
          className="border-1 mt-4 w-full border-black"
          scroll={{ x: "100%" }}
        />
        <div className="mt-4 flex flex-col justify-between sm:mt-10 sm:flex-row">
          <div className="flex flex-col gap-3">
            <p>{t("responsiblePerson")}</p>
            <Input
              value={responsiblePerson}
              disabled
              className="flex h-12 w-full items-center justify-center sm:w-[300px]"
            />
          </div>
        </div>
        <div className="flex flex-col gap-3 sm:mt-10">
          <div className="flex items-center gap-2">
            <span className="font-bold">{t("statusSale")} : </span>
            <Tag className="text-sm" color={"blue"}>
              {status}
            </Tag>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-bold">{t("deliveryConfirmedTime")} : </span>

            {salesData?.salesOrderTime && (
              <Tag color={"blue"}>
                {moment(salesData?.salesOrderTime).format("DD-MM-YYYY HH:mm")}
              </Tag>
            )}
          </div>

          <div className="flex items-center gap-2">
            <span className="font-bold">{t("timeRp")} : </span>

            {salesData?.orderToDeliveryTime && (
              <Tag color={"blue"}>
                {moment(salesData?.orderToDeliveryTime).format(
                  "DD-MM-YYYY HH:mm",
                )}
              </Tag>
            )}
          </div>

          <div className="flex items-center gap-2">
            <span className="font-bold">{t("deliveredTime2")} : </span>
            {salesData?.orderDeliveredTime && (
              <Tag color={"blue"}>
                {moment(salesData?.orderDeliveredTime).format(
                  "DD-MM-YYYY HH:mm",
                )}
              </Tag>
            )}
          </div>

          <div className="flex items-center gap-2">
            <span className="font-bold">{t("confirmDeliveryTime")} : </span>

            {salesData?.deliveredTime && (
              <Tag color={"blue"}>
                {moment(salesData?.deliveredTime).format("DD-MM-YYYY HH:mm")}
              </Tag>
            )}
          </div>

          <div className="flex items-center gap-2">
            <span className="font-bold">{t("loadingTime")} : </span>

            {salesData?.loadingTime && (
              <Tag color={"blue"}>
                {moment(salesData?.loadingTime).format("HH:mm:ss")}
              </Tag>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AcceptedModal;
